import produce from "immer";
import * as types from "./actionTypes";
import { UserRole } from "common/";

export interface AuthReducer {
  current_user: UserReducer;
  idToken: string;
}
export interface UserReducer {
  roles: string[];
  role: (typeof UserRole)[keyof typeof UserRole];
  email: string;
  displayName: string;
  userName?: string;
  phone: string;
  id: string;
  isLogin: boolean;
  isAdmin: boolean;
  isApproved: boolean;
  devices: any[];
  lastMethod?: string;
  totalServices: number;
  imageUrl?: string;
  locationText?: string;
  volunteerMinutes?: number;
  rank?: number;
}

const initialUser = {
  roles: [],
  email: "",
  displayName: "",
  phone: "",
  id: "",
  isLogin: false,
  isAdmin: false,
} as UserReducer;

const initial = {
  current_user: initialUser,
  idToken: "",
} as AuthReducer;

export const authReducer = (state = initial, action: any) =>
  produce(state, (draft) => {
    switch (action.type) {
      case types.SET_CURRENT_USER:
        draft.current_user = transformRole(action.current_user);
        draft.idToken = action.current_user.token;
        break;
      case types.UPDATE_CURRENT_USER:
        const formatedUser = transformRole(action.current_user);

        (Object.keys(formatedUser) as (keyof UserReducer)[]).forEach(
          (field) => {
            const value = formatedUser[field];
            if (value !== undefined) {
              (draft.current_user as Record<string, unknown>)[field] = value;
            }
          }
        );
        break;
      case types.CLEAR_AUTH:
        draft.current_user = initialUser;
        draft.idToken = "";
        break;
      case types.UPDATE_TOTAL_SERVICES:
        draft.current_user.totalServices = action.current_user.totalServices;
        break;
      default:
        return draft;
    }
    return draft;
  });

const transformRole = (userInfo) => {
  if (userInfo.roles) {
    if (userInfo.roles.includes(UserRole.Administrator)) {
      return {
        ...userInfo,
        isAdmin: true,
        role: UserRole.Administrator,
      };
    }
    if (userInfo.roles.includes(UserRole.Volunteer)) {
      return {
        ...userInfo,
        isAdmin: false,
        role: UserRole.Volunteer,
      };
    }
    if (userInfo.roles.includes(UserRole.VolunteerLead)) {
      return {
        ...userInfo,
        isAdmin: false,
        role: UserRole.VolunteerLead,
      };
    }
    if (userInfo.roles.includes(UserRole.VolunteerSenior)) {
      return {
        ...userInfo,
        isAdmin: false,
        role: UserRole.VolunteerSenior,
      };
    }
    if (userInfo.roles.includes(UserRole.User)) {
      return {
        ...userInfo,
        isAdmin: false,
        role: UserRole.User,
      };
    }
  }

  return userInfo;
};
